import React from "react";
import { E404 } from "../Components";

export const PageNotFound = () => {
  return <E404 />;
};
